@if (canUse()) {
  <div
    class="support-launcher"
    [class.is-dragging]="dragPoint()"
    [style.left.px]="dragPoint() ? dragPoint()!.x : null"
    [style.top.px]="dragPoint() ? dragPoint()!.y : null"
  >
    <button
      #trigger
      type="button"
      class="support-launcher__fab"
      [attr.title]="'SUPPORT.LAUNCHER.DRAG_HINT' | translate"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerCancel()"
      (lostpointercapture)="onLostPointerCapture()"
      aria-controls="support-panel"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-label]="
        unread() > 0
          ? ('SUPPORT.LAUNCHER.OPEN_WITH_UNREAD' | translate: { count: badge() })
          : ('SUPPORT.LAUNCHER.OPEN' | translate)
      "
      (click)="toggle()"
    >
      <i class="bx" [class.bx-support]="!isOpen()" [class.bx-x]="isOpen()" aria-hidden="true"></i>
      @if (unread() > 0) {
        <span class="support-launcher__badge" aria-hidden="true">{{ badge() }}</span>
      }
    </button>
  </div>

  <!-- Loaded on first open, then kept (hidden) so drafts survive closing the panel. -->
  @defer (when isOpen(); prefetch on hover(trigger)) {
    <app-support-panel [hidden]="!isOpen()" />
  }
}
